//Accordion
(function ($) {
    function googleReviewsSlider() {

        const googleReviewsSwiper = new Swiper('.google-reviews-slider > .container', {
            // Optional parameters
            modules: [SwiperNavigation],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 18,
            speed: 500,
            navigation: {
                nextEl: '.google-reviews-slider__list-nav-next',
                prevEl: '.google-reviews-slider__list-nav-prev',
            },

            breakpoints: {
                // when window width is >= 767px
                767: {
                    slidesPerView: 2
                },
                // when window width is >= 640px
                1199: {
                    slidesPerView: 3
                }
            }
          });
    }

    googleReviewsSlider();
})(jQuery);